import { getChannelContextCode } from 'helpers/Utility';
import { setError } from 'store/actions/auth';
import { loading } from 'store/actions/loanApply';

/**
 * to handle error verify payroll
 * @param {*} dispatch
 * @param {*} err
 * @returns
 */
export const handleErrorVerifyPayroll = (dispatch, err) => {
  const setDispatchError = errorKey => {
    dispatch(setError(errorKey));
    dispatch(loading(false));
  };

  if (!err.response) return setDispatchError('connection');

  const channelCode = getChannelContextCode(err, 'channel-context');

  const errorMap = {
    5100: 'account_bri_not_found',
    211047: 'general_error',
    211048: 'contact-cs',
    211049: 'account_is_not_open',
    211052: 'getting_older_young',
    211053: 'error_minimum_balance',
    1011: 'error_cocd'
  };

  if (errorMap[channelCode]) return setDispatchError(errorMap[channelCode]);
  if (channelCode === null) return setDispatchError('system');

  return setDispatchError('system');
};
